import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData, ReelState} from "../../../core/reel/ReelState";
import {WalkOfShameSound} from "../../sound/WalkOfShameSound";
import {WalkOfShame} from "../../WalkOfShame";
import {WalkOfShameSymbolState} from "../../symbol/WalkOfShameSymbolConfig";
import {WalkOfShameGameConfig} from "../../WalkOfShameGameConfig";
import {WalkOfShameSymbol} from "../../symbol/WalkOfShameSymbol";

export class ReelStopSoundController extends ReelStopPresentationController {
    private _spinStates: boolean[];
    private _soundPlayed: boolean = false;

    constructor() {
        super('ReelStopSoundController');
    }

    public async start(): Promise<any> {
        this._spinStates = WalkOfShame.reels.map(reel => reel.reelState === ReelState.SPIN);
        await super.start();
    }

    protected onReelBounce(data: IReelStateEventData): Promise<void> {
        const reelId: number = data.reelId;

        this._spinStates[reelId] = false;
        if (this._spinStates.every(s => !s)) {
            WalkOfShameSound.soundPlayer.stopTrack(WalkOfShameSound.REELS_SPINNING);
        }

        if (this.checkMToWildFeatureOnReel(reelId)) {
            WalkOfShameSound.soundPlayer.playTrack({
                name: WalkOfShameSound.WILD_LAND
            });

            if (!this._soundPlayed && WalkOfShame.model.parsedGameData.mode.indexOf("RESPIN") === -1 && WalkOfShame.model.parsedGameData.nextMode.indexOf("RESPIN") > -1) {
                WalkOfShameSound.soundPlayer.playTrack({
                    name: WalkOfShameSound.WALK_OF_SHAME_START
                });

                WalkOfShameSound.switchMusic({
                    name: WalkOfShameSound.WALK_OF_SHAME_LOOP,
                    volume: 1
                }, undefined, {
                    name: "",
                    to: 0,
                    duration: 200
                }, false);

                this._soundPlayed = true;
            }
        } else {
            WalkOfShameSound.playRandomReelStopSound(reelId);

            if (WalkOfShame.model.parsedGameData.mode.indexOf("RESPIN") > -1) {
                this.tryTurningOffSymbols(reelId);
            }
        }

        this.tryDimmingNoWinSymbols(reelId);

        return super.onReelBounce(data);
    }

    protected reset(): void {
        super.reset();

        this._soundPlayed = false;
    }

    private checkMToWildFeatureOnReel(reel: number): boolean {
        for (let ctr: number = 0; ctr < WalkOfShame.model.parsedGameData.mToWildFeature.length; ctr++) {
            if (reel === WalkOfShame.model.parsedGameData.mToWildFeature[ctr].reel) {
                return true;
            }
        }

        return false;
    }

    // #87
    private tryDimmingNoWinSymbols(reelId: number): void {
        const reelWinPositionsAll: boolean[][] = WalkOfShame.model.parsedGameData.reelWinPositionsAll;
        if (reelWinPositionsAll.length > 0) {
            if (reelId === 2) {
                for (let reel: number = 0; reel <= reelId; reel++) {
                    for (let symId: number = 0; symId < reelWinPositionsAll[reel].length; symId++) {
                        if (!reelWinPositionsAll[reel][symId]) {
                            WalkOfShame.reels[reel].getSymbol(symId + 1).getStateAnimation(
                                WalkOfShameSymbolState.NO_WIN
                            );

                            WalkOfShame.symbolCount.tintItemToNoWin(reel, symId);
                        }
                    }

                    // #142
                    if (reel === 0 && WalkOfShame.stickyS2.visible) {
                        const animName: string = (WalkOfShame.model.parsedGameData.mode.indexOf("RESPIN") > -1 ? "noWinRespin" : "noWin");

                        WalkOfShame.stickyS2.playS2Animation(animName, false);
                    }
                }
            } else if (reelId > 2) {
                for (let symId: number = 0; symId < reelWinPositionsAll[reelId].length; symId++) {
                    if (!reelWinPositionsAll[reelId][symId]) {
                        WalkOfShame.reels[reelId].getSymbol(symId + 1).getStateAnimation(
                            WalkOfShameSymbolState.NO_WIN
                        );

                        WalkOfShame.symbolCount.tintItemToNoWin(reelId, symId);
                    }
                }

                if (reelId === 4 && WalkOfShameGameConfig.FULL_SYM_PRESENT_LAST_REEL && !reelWinPositionsAll[4][0]) {
                    WalkOfShame.mToWild.canApplyNoWin = true;
                }
            }
        }
    }

    private tryTurningOffSymbols(reelId: number): void {
        if (WalkOfShame.mToWild.ifFullSymExistsOnReel(reelId)) {
            const allSymbols: WalkOfShameSymbol[] = WalkOfShame.reels[reelId].reelView.allSymbols;

            for (let idx: number = 1; idx < allSymbols.length - 1; idx++) {
                allSymbols[idx].visible = false;
            }
        }
    }
}